import { TemplateWizardProps } from './TemplateWizard';
import TemplateWizardRouter from './TemplateWizardRouter';

export default TemplateWizardRouter;
export { TemplateWizardProps };
